import RioClient, { initClient } from './client';
import { EventData, ViewCurrent } from './types';
import sendEvent from './events/sendEvent';
import setCurrentView from './events/setCurrentView';
export { RioClient, initClient, sendEvent, setCurrentView, EventData, ViewCurrent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio2-web-client/dist/esm/index.js
// module id = 724
// module chunks = 11